import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const StudioEmbed = lazy(() => import("@/components/StudioEmbed"));

export const Route = createFileRoute("/admin/$")({
  component: AdminPage,
  ssr: false,
});

function AdminPage() {
  return (
    <Suspense fallback={<div style={{ display: "grid", placeItems: "center", height: "100vh" }}>Loading Studio…</div>}>
      <StudioEmbed />
    </Suspense>
  );
}
